import BaseService from '../../base/base_service';
import _ from '../../utils/underscore';
import ITripleEightService from './triple_eight_service_interface';

interface TripleEightServiceParams {
    readonly useGameLauncher: boolean;
    readonly gameLauncherUrl: string;
    readonly isUsingGGPMock: boolean;
}

export default class TripleEightService extends BaseService implements ITripleEightService {

    static CLASS = 'TripleEightService';

    _params: TripleEightServiceParams;

    init(params: TripleEightServiceParams) {
		super.init(params);
        this._params = {
			useGameLauncher: params.useGameLauncher || false,
			gameLauncherUrl: params.gameLauncherUrl || '',
			isUsingGGPMock: params.isUsingGGPMock || false
		}
    }

     isUsingGGPMock(): boolean {
    	return this._params.isUsingGGPMock;
	}

	gameLauncherUrl(): string {
        return this._params.gameLauncherUrl;
	}

	useGameLauncher(): boolean {
		return this._params.useGameLauncher &&
			_.isString(this._params.gameLauncherUrl) && this._params.gameLauncherUrl.length > 0;
	}
}
